import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import type { CountryDto } from '@sal/location/application/dtos';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CountryService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = environment.endpoint;

    public getCountryDetailData(countryCode: string, province?: string): Observable<CountryDto | null> {
        const url = `${this.apiUrl}/countries/${encodeURIComponent(countryCode)}`;
        const params = province ? new HttpParams().set('province', province) : new HttpParams();

        return this.http.get<CountryDto>(url, { params }).pipe(catchError(() => of(null)));
    }
}
